module.exports = __webpack_public_path__ + "static/media/homekit.fb35810f.png";